module.exports = __webpack_public_path__ + "img/tvRight.1d766963.png";